import { Reveal, SectionHead } from "@/components/Reveal";
import WaitlistForm from "@/components/WaitlistForm";

const SYSTEMS = [
  {
    number: "01",
    name: "FOUNDER OS",
    target: "For founders building the company.",
    description:
      "A practical framework for turning an idea into a focused business — from strategy and prioritization to execution, systems and growth.",
    testid: "os-card-founder",
  },
  {
    number: "02",
    name: "BUSINESS OS",
    target: "For service businesses building a more scalable way of working.",
    description:
      "A framework for improving how the business operates — from processes and capacity to delegation, automation and AI.",
    testid: "os-card-business",
  },
  {
    number: "03",
    name: "NONPROFIT OS",
    target: "For nonprofits strengthening the organization behind the mission.",
    description:
      "A practical framework for building stronger programs, processes, organizational capacity and sustainable ways of working.",
    testid: "os-card-nonprofit",
  },
];

export default function OperatingSystems() {
  return (
    <section
      id="operating-systems"
      data-testid="os-section"
      className="scroll-mt-20 border-y border-line bg-parch py-20 sm:py-28 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          chapter="04 — The KP Strategy OS"
          title="One philosophy. Three operating systems."
          copy="KP Strategy turns product management thinking into practical operating frameworks for how organizations decide, build, operate and improve."
          testid="os-head"
        />

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8">
          {SYSTEMS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.1} className="h-full">
              <div
                data-testid={s.testid}
                className="flex h-full flex-col border border-ink/15 bg-paper p-8 transition-all duration-300 hover:-translate-y-1 hover:border-amber/60 sm:p-10"
              >
                <p className="font-mono text-[11px] text-amber">{s.number}</p>
                <div className="mt-3 flex items-center justify-between gap-4">
                  <h3 className="font-mono text-sm font-semibold uppercase tracking-[0.2em] text-ink">
                    {s.name}
                  </h3>
                  <span className="whitespace-nowrap rounded-full border border-amber/50 bg-amber-soft px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-amber-dark">
                    Coming Soon
                  </span>
                </div>
                <span className="mt-6 block h-px w-full bg-line" />
                <p className="mt-6 font-serif text-xl font-light leading-snug text-ink">
                  {s.target}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-body">
                  {s.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-10 flex items-baseline gap-3 font-mono text-xs uppercase tracking-[0.2em] text-faint">
            <span className="inline-block h-px w-8 bg-amber" aria-hidden="true" />
            Coming soon: playbooks, journals, templates and practical tools to help you put the OS into practice.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div
            data-testid="os-waitlist-strip"
            className="mt-8 flex flex-col gap-6 border-t border-ink/10 pt-8 lg:flex-row lg:items-center lg:justify-between"
          >
            <div>
              <p className="font-serif text-xl font-light text-ink">
                Want to know when they&apos;re ready?
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-body">
                Leave your email and we&apos;ll keep you posted.
              </p>
            </div>
            <div className="w-full lg:max-w-md">
              <WaitlistForm testid="home-os-waitlist" centered={false} />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
